var map = {
	"./en-US.js": "296e",
	"./index.js": "bf0f",
	"./ja-JP.js": "1564",
	"./ko-KR.js": "9e69f",
	"./vi-VN.js": "10fc",
	"./zh-TW.js": "144c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9118";